import { ChangeDetectionStrategy, Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import type { SrmTicketStatusType } from '@libs/services/models';
import { SrmHelperService } from '../srm-helper.service';

@Component({
  selector: 'ui-srm-ticket-status',
  templateUrl: './srm-ticket-status.component.html',
  styleUrls: ['./srm-ticket-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SrmTicketStatusComponent {
  public readonly helperService: SrmHelperService = inject(SrmHelperService);
  public status: InputSignal<SrmTicketStatusType | undefined> = input.required();
  public statusText: Signal<string> = computed(() => this.helperService.translateStatus(this.status()));
  public statusClass: Signal<string> = computed(() => this.helperService.statusStyle(this.status()));
}
